import { action } from 'satcheljs';

export const incrementSidepaneClickCountAction: () => {} = action('INCREMENT_SIDEPANE_CLICK_COUNT');
